import * as z from "zod";

/** Leading characters a spreadsheet evaluates as a formula; the API refuses them as a stored
 * CSV-injection risk. */
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

/**
 * Validates the *trimmed* title, which is what the request carries — checking the raw input would
 * disagree with the server on a value like " -Grant".
 *
 * The minimum of 1 mirrors the API, which rejects a blank title. The message for it is never
 * rendered: an untouched field stays quiet and simply leaves the submit button disabled, so the
 * operator is not scolded for a form they have not filled in yet.
 */
export const bulkScholarshipTitleSchema = z
  .string()
  .min(1, "Scholarship name is required.")
  .max(500, "Scholarship name must be 500 characters or fewer.")
  .refine((value) => !FORMULA_PREFIX.test(value), {
    message: "Scholarship name cannot start with =, +, -, @, a tab, or a carriage return.",
  });
